























import _ from "underscore";
import { Component, Prop, Vue } from "vue-property-decorator";

import ListArea from "@/components/common/list/ListArea.vue";
import ListItem from "@/components/common/list/ListItem.vue";
import ListItemRow from "@/components/common/list/ListItemRow.vue";
import GreenUnderlineText from "@/components/common/text/GreenUnderlineText.vue";
import EventListItem from "@/components/event/EventListItem.vue";
import { ServiceMenuEventInterface } from "@/interfaces/service-menu-event.interface";
import { EventUtil } from "@/utils/event.util";

interface YearEventList {
  year: string;
  events: ServiceMenuEventInterface[];
}

@Component({
  components: {
    GreenUnderlineText,
    EventListItem,
    ListItem,
    ListItemRow,
    ListArea,
  },
})
export default class EventList extends Vue {
  @Prop({ required: true }) events!: ServiceMenuEventInterface[];

  private get yearEventLists(): YearEventList[] {
    return this.parse(this.getYears(this.events), this.events);
  }

  private getYears(events: ServiceMenuEventInterface[]): string[] {
    return _.uniq(
      events.map((event: ServiceMenuEventInterface) => this.getYear(event))
    )
      .sort()
      .reverse();
  }

  private parse(
    years: string[],
    events: ServiceMenuEventInterface[]
  ): YearEventList[] {
    const data: { [key: string]: ServiceMenuEventInterface[] } = {};

    years.forEach((year: string) => {
      data[year] = [];
    });
    events.forEach((event: ServiceMenuEventInterface) => {
      data[this.getYear(event)].push(event);
    });

    return years.map((year: string) => ({
      year: year,
      events: data[year],
    }));
  }

  private getYear(event: ServiceMenuEventInterface): string {
    return EventUtil.getYear(event.eventDate);
  }

  private onClickEvent(event: ServiceMenuEventInterface): void {
    this.$emit("click-event", event);
  }
}
